// extracted by mini-css-extract-plugin
export default {"formItem":"style_formItem__VaWau","formItemLabel":"style_formItemLabel__HYI+B","star":"style_star__D-Eup"};